export const getSpecialAllCards = (state) => state.special.allCards
export const getSpecialCards = (state) => state.special.cards
export const getSpecialStatus = (state) => state.special.status
export const getSpecialError = (state) => state.special.error
export const getSpecialDirection = (state) => state.special.direction
export const getSpecialArrayCard = (state) => state.special.arrayCard
export const getSpecialIsLoaded = (state) => state.special.isLoaded
export const getSpecialCollection = (state) => state.special.collection